import { HTTP } from './http';

export const requestAnswer = (model) => new Promise((resolve, reject) => HTTP.post('/answers',
  {
    response: model,
    last_question_answered: model[model.length-1].question,
  })
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestAddAnswer = (id, model) => new Promise((resolve, reject) => HTTP.post(`/answers/${id}/add-answer`,
  {
    response: model,
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestUpdateAnswer = (id, model) => new Promise((resolve, reject) => HTTP.patch(`/answers/${id}/add-or-update-answer`,
  {
    response: model,
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestUpdateUserResponse = (id, model) => new Promise((resolve, reject) => HTTP.patch(`/answers/${id}`,
  {
    response: model,
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/answers.js